import { InsightsOverTimeBinDtoModelSelector } from '../../../models';

export const completedWorkingTimeFragment = (selector: InsightsOverTimeBinDtoModelSelector) => selector.interval.value;
